import { useLayoutEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  getTenantIdFromPathname,
  navigateWithTenant,
  resolveBootstrapTenantId,
  setSessionLastTenantId,
  updateAuthUserSelectedTenant,
  userCanAccessTenantId,
  withTenantIdInPathname,
} from '@app-store'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import PageLayout from '../../layouts/PageLayout'

function skipTenantEnforcement(pathname: string): boolean {
  return (
    pathname.startsWith('/logout') ||
    pathname.startsWith('/error') ||
    pathname.startsWith('/docuSign')
  )
}

export function TenantScopedLayout() {
  const location = useLocation()
  const navigateBase = useNavigate()
  const { tenantId } = useParams()
  const dispatch = useAppDispatch()
  const user = useAppSelector((s: RootState) => s.authUser.user)
  const selectedClient = useAppSelector(
    (s: RootState) => s.authUser.selectedClientTenant
  )

  const parsed =
    tenantId != null && tenantId !== '' ? parseInt(tenantId, 10) : NaN
  const urlTenantValid =
    Boolean(user) &&
    Number.isFinite(parsed) &&
    userCanAccessTenantId(user!, parsed)

  useLayoutEffect(() => {
    if (!user) return
    if (skipTenantEnforcement(location.pathname)) return

    if (Number.isFinite(parsed) && userCanAccessTenantId(user, parsed)) {
      if (selectedClient?.id !== parsed) {
        dispatch(updateAuthUserSelectedTenant(parsed))
      }
      setSessionLastTenantId(parsed)
      return
    }

    const fromSlice = resolveBootstrapTenantId(user, selectedClient)
    const fromPath =
      getTenantIdFromPathname(location.pathname) != null
        ? location.pathname.replace(/^\/-?\d+/, '') || '/'
        : location.pathname
    const newPathname = withTenantIdInPathname(
      fromPath.startsWith('/') ? fromPath : `/${fromPath}`,
      fromSlice
    )
    navigateWithTenant(
      navigateBase,
      {
        pathname: newPathname,
        search: location.search,
        hash: location.hash,
      },
      { replace: true },
      fromSlice
    )
  }, [
    user,
    location.pathname,
    location.search,
    location.hash,
    navigateBase,
    dispatch,
    selectedClient?.id,
    tenantId,
    parsed,
  ])

  if (!user) {
    return <PageLayout />
  }
  if (skipTenantEnforcement(location.pathname)) {
    return <PageLayout />
  }
  if (!urlTenantValid) {
    return null
  }
  return <PageLayout />
}
